import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-bolder text-muted" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-50px" }, " Weight ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-100px" }, "Name", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-100px" }, "Worker Description", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-100px" }, "Company Description", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-lg-100px" }, "Document Needed", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "Actions", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "" }, null, -1)
const _hoisted_9 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, _hoisted_9))
}